import React from 'react';
import { Container, Heading } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import EstimationHeader from './EstimationHeader';
import ClaimEstimationLearnMoreButton from './ClaimEstimationLearnMoreButton';

const ClaimsEstimationMobile: React.FC = () => (
  <Container
    maxW="xl"
    d={{ base: 'flex', desktop: 'none' }}
    flexDir="column"
    px={0}
  >
    <EstimationHeader mb={500} />
    <Heading size={300} isLight>
      Easy Imports
    </Heading>
    <Heading size={200} isDisplay marginBottom={700}>
      Import 3D model data and accurate measurements directly into your claims
      management tool of choice. No manual sketching required.
    </Heading>
    <StaticImage
      quality={100}
      placeholder="blurred"
      alt="insurance easy import"
      src="../../../assets/images/insurance_easy_import.png"
    />
    <Heading size={300} isLight mt="72px">
      Better Estimates
    </Heading>
    <Heading size={200} isDisplay marginBottom={700}>
      Better measurements means more accurate estimations. Minimize errors and
      settle property claims quickly and more accurately.
    </Heading>
    <Heading size={200} isDisplay marginBottom={700}>
      Create precise estimates in Xactimate with our .esx file outputs, or
      connect directly with Symbility or Filetrac.
    </Heading>
    <StaticImage
      quality={100}
      placeholder="blurred"
      alt="fast estimation"
      src="../../../assets/images/insurance_fast_estimation.png"
    />
    <ClaimEstimationLearnMoreButton />
  </Container>
);

export default ClaimsEstimationMobile;
